import React from 'react';
import { Link2Icon } from '@radix-ui/react-icons';

import styles from './settings-action.module.scss';
type SettingsActionProps = {
  title: string;
  icon: React.ReactNode;
  action: React.ReactNode;
  name?: string;
  hint?: string;
};

export const SettingsAction: React.FC<SettingsActionProps> = ({
  title,
  icon,
  action,
  name,
  hint,
}) => (
  <div className={styles['container']}>
    {name && <h3 className={styles['name']}>{name}</h3>}

    <div className={styles['card']}>
      <div className={styles['header']}>
        <div className={styles['content']}>
          <div className={styles['icon']}>{icon}</div>
          <p>{title}</p>
        </div>

        {action}
      </div>

      {hint && (
        <div className={styles['footer']}>
          <div className={styles['icon']}>
            <Link2Icon />
          </div>
          <span dangerouslySetInnerHTML={{ __html: hint }} />
        </div>
      )}
    </div>
  </div>
);
